import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { makeStyles, Tab, Tabs, TextareaAutosize, Theme } from '@material-ui/core';

import { Page } from '../../components/Page';
import { BackAppBar } from '../../components/BackAppBar';
import { PageBody } from '../../components/PageBody';
import { FormGroup } from '../../components/FormGroup';
import { TextField } from '../../components/TextField';
import { useSetting } from '../../units/setting';
import { TabPanel } from '../../components/TabPanel';
import { FeedbackList } from './components/FeedbackList';
import { useFrontVodList } from '../../hooks/useFrontVodList';
import { FrontVod } from '../../data/FrontVod';
import { usePartner } from '../../hooks/usePartner';

type FeedbackHistoryPageProps = {};

FeedbackHistoryPage.defaultProps = {};

const useStyles = makeStyles((theme: Theme) => ({}));

const TabValue = {
    List: 'List',
    Detail: 'Detail',
};

function FeedbackHistoryPage(props: FeedbackHistoryPageProps): React.ReactElement {
    const classes = useStyles();
    const history = useHistory();
    const [selectedTab, setSelectedTab] = useState(TabValue.List);
    const [selectedVod, setSelectedVod] = useState<FrontVod | null>(null);
    const { partner, partnerLineUid } = usePartner();
    const { frontVodList } = useFrontVodList({
        login: partner?.email || '',
        line_uid: partnerLineUid || '',
    });

    function handleItemMoreClick(item: FrontVod) {
        setSelectedVod(item);
        setSelectedTab(TabValue.Detail);
    }

    return (
        <Page>
            <BackAppBar title="意見反饋" onBackClick={() => history.replace('/feedback')}>
                <Tabs
                    value={selectedTab}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                    onChange={(e, v) => setSelectedTab(v)}
                >
                    <Tab label="紀錄列表" value={TabValue.List} />
                    <Tab label="紀錄明細" value={TabValue.Detail} />
                </Tabs>
            </BackAppBar>
            <TabPanel value={selectedTab} index={TabValue.List}>
                <FeedbackList
                    feedbackList={frontVodList}
                    onItemMoreClick={handleItemMoreClick}
                />
            </TabPanel>
            <TabPanel value={selectedTab} index={TabValue.Detail}>
                <PageBody>
                    <FormGroup title="問題類別">
                        <TextField
                            label="問題主分類"
                            value={selectedVod && selectedVod.main_category_name}
                            disabled
                        />
                        <TextField
                            label="問題次分類"
                            value={selectedVod && selectedVod.sub_category_name}
                            disabled
                        />
                    </FormGroup>
                    <FormGroup title="問題內容">
                        <TextField
                            minRows={6}
                            multiline
                            value={selectedVod && selectedVod.question}
                            disabled
                            helperText={selectedVod && `反映日期: ${selectedVod.create_date}`}
                        />
                    </FormGroup>
                    <FormGroup title="回覆內容">
                        <TextField
                            minRows={6}
                            multiline
                            value={selectedVod && selectedVod.answer}
                            disabled
                            helperText={selectedVod && `回覆日期: ${selectedVod.reply_date}`}
                        />
                    </FormGroup>
                </PageBody>
            </TabPanel>
        </Page>
    );
}

export { FeedbackHistoryPage };
